import { forwardRef, useId } from 'react';
import { cn } from 'lib/cn';

/** Labelled checkbox. */
export const Checkbox = forwardRef(function Checkbox({ label, id, className, ...props }, ref) {
  const autoId = useId();
  const checkboxId = id || autoId;

  return (
    <label
      htmlFor={checkboxId}
      className={cn('flex cursor-pointer items-center gap-2 text-sm text-slate-700', className)}
    >
      <input
        id={checkboxId}
        ref={ref}
        type="checkbox"
        className="h-4 w-4 rounded border-surface-300 text-brand-600 focus:ring-brand-500"
        {...props}
      />
      {label}
    </label>
  );
});

export default Checkbox;
